declare const HIP: any;
declare const log: any;

import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { PlatformUtility } from 'utility-ts-platform';
import { ICustomTextEntry } from '../../src/holds_interface';
import { HoldsCustomTextModel } from '../../src/models/custom_text_model';

export class HoldsService {
  private realtimeChannelActive: boolean = false;
  private customText: ICustomTextEntry[];
  private holdsUrl: string = '';
  private state: any;
  private isMobile: boolean = false;
  constructor(
    private pusherService: any,
    private accountModel: any,
    private ngHoldsCustomTextModel: HoldsCustomTextModel,
    private $state: ng.ui.IStateService,
    private loadHoldsCustomTextCommand: ICommand,
    private loadHoldsCommand: ICommand
  ) {
    this.isMobile = PlatformUtility.isMobile();
  }

  init() {
    return new Promise((resolve, reject) => {
      if (_4.isEmpty(this.ngHoldsCustomTextModel.read())) {
        this.loadCustomText()
          .then(() => {
            this.startPusherChannel();
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      } else {
        this.startPusherChannel();
        resolve();
      }
    });
  }

  startPusherChannel() {
    this.customText = this.ngHoldsCustomTextModel.read();
    this.state = this.$state;
    if (!this.realtimeChannelActive) {
      this.realtimeChannelActive = true;
      this.pusherService.bindToPusherEvent(this.accountModel.username, 'realtime_update', (pusherResponse: any) => {
        const text = _4.get(_4.find(this.customText, { nk: pusherResponse.message_key }), 'text') || '';
        const title = `Attention: New Hold(s)`;
        this.holdsUrl = this.state.href('my.holdscenter');
        this.loadHoldsCommand(false);
        if (!this.isMobile) {
          HIP.fn.notify({
            title,
            details: `
              <div l-kind="hort" l-no-wrap l-justify="between">
              <hi-link href="${this.holdsUrl}">${text}</hi-link>
              <hi-badge theme="orange" aesthetic="light">
                <hi-icon theme="orange" kind="warning"></hi-icon>
                <span class="text-sz-m">Holds</span>
              </hi-badge>
              </div>`,
            delay: 20000
          });
        } else {
          log.notify({
            title,
            body: `<hi-link ui-sref="my.holdscenter">${text}</hi-link>`
          });
        }
      });
    }
  }

  loadCustomText() {
    return this.loadHoldsCustomTextCommand();
  }

  disconnect() {
    this.pusherService.unBindToPusherEvent('', 'realtime_update');
    this.realtimeChannelActive = false;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-holds/src/services/holds_service.ts